// @ts-check

/**
 * @param {import("../types").CSSStyle} style
 * @param {HTMLElement} element
 * @returns {void}
 */
function applyCSSStyleToElement(style, element) {
  for (const property in style) {
    if (Object.hasOwnProperty.call(style, property)) {
      const value = style[property]
      if (value) element.style[property] = value
    }
  }
}

/**
 * @param {import("../types").VerticalPosition} position
 * @returns {'flex-start'|'center'|'flex-end'}
 */
function verticalPositionToFlex(position) {
  switch (position) {
    case 'top':
      return 'flex-start'

    case 'bottom':
      return 'flex-end'

    default:
    case 'middle':
      return 'center'
  }
}

/**
 * @param {import("../types").HorizontalPosition} position
 * @returns {'flex-start'|'center'|'flex-end'}
 */
function horizontalPositionToFlex(position) {
  switch (position) {
    case 'left':
      return 'flex-start'

    case 'right':
      return 'flex-end'

    default:
    case 'center':
      return 'center'
  }
}

export {
  applyCSSStyleToElement,
  verticalPositionToFlex,
  horizontalPositionToFlex,
}
